import { isChunkLoadError, isReloadingForStaleChunk } from './chunkReload';

/**
 * Whether a caught error means "this tab runs an older build". Besides the
 * chunk errors themselves, that is anything caught while a stale-chunk reload
 * is on its way: cancelling `vite:preloadError` leaves the route's
 * `.then(m => m.Page)` a TypeError on undefined. If the new document takes
 * longer than the pending window, the fallback comes back for that TypeError,
 * and "Try again" can never work — React.lazy caches the rejection.
 *
 * Call it once, when the error is caught: the pending window expires, and the
 * answer must not change with it.
 */
export function isStaleBuildError(error: unknown): boolean {
  return isChunkLoadError(error) || isReloadingForStaleChunk();
}
